import React from "react";
import UseContext from "hooks/useContext";
import ActivityTemplate from "pages/missionTemplates/body/activity.template";
import RiskyPositionTemplate from "pages/missionTemplates/body/RiskyPositionTemplate";
import PrerequisTemplate from "pages/missionTemplates/body/prerequis.template";
import TasksTemplate from "pages/missionTemplates/body/TasksTemplate";
import LocationSalaryTemplate from "pages/missionTemplates/body/locationSalary.template";
import ConfirmationTemplate from "pages/missionTemplates/body/confirmation.template";
import {
    TEMPLATE_STEP,
    getTemplateStepKey,
} from "pages/missionTemplates/templateSteps";

// Kept out of templateSteps.js: the confirmation step imports it, so listing the
// components there would create an import cycle.
const STEP_COMPONENTS = {
    [TEMPLATE_STEP.ACTIVITY]: ActivityTemplate,
    [TEMPLATE_STEP.RISKY_POSITION]: RiskyPositionTemplate,
    [TEMPLATE_STEP.PREREQUIS]: PrerequisTemplate,
    [TEMPLATE_STEP.TASKS]: TasksTemplate,
    [TEMPLATE_STEP.LOCATION_SALARY]: LocationSalaryTemplate,
    [TEMPLATE_STEP.CONFIRMATION]: ConfirmationTemplate,
};

const TemplateFormsCreate = () => {
    const { templatePage } = UseContext();
    const stepKey = getTemplateStepKey(templatePage);
    const StepComponent = STEP_COMPONENTS[stepKey];
    return StepComponent ? <StepComponent key={stepKey} /> : null;
};

export default TemplateFormsCreate;
